import {Box, Button, FormControlLabel, Switch, Typography} from "@mui/material";
import {getInitialStyle, StyleOptions} from "../../../utility/Style";
import {FormattingStyleOptions} from "../../sheets/conditionalFormatting/StyleOptions";
import {Delete} from "@mui/icons-material";
import React, {useCallback, useContext} from "react";
import {IConstant} from "./Constant";
import {FirebaseContext} from "../../firebase/FirebaseProvider";
import makeStyles from "@mui/styles/makeStyles";
import {ConfirmContext} from "../../../utility/ConfirmProvider";
import {DateTimePicker} from "../../tags/DateTimePicker";

const useStyles = makeStyles((theme) => ({
    form: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        marginBottom: theme.spacing(1)
    },
}));

interface IChipDetails {
    constant: IConstant
    id: string
    project: string
    value: any
}
export function ChipDetails({constant, id, project, value}: IChipDetails) {
    const classes = useStyles();
    const confirm = useContext(ConfirmContext);
    const {remove, set} = useContext(FirebaseContext);
    const setChipStyle = useCallback((constant: string, styleOptions: StyleOptions | "auto") =>
    {
        return set(`constants/${project}/${constant}/chip`, styleOptions);
    }, [set, project])
    const handleDeleteChip = (event: React.MouseEvent<HTMLElement>) =>
    {
        const constant = event.currentTarget.dataset.constant;
        if (constant)
        {
            confirm(<Typography>Delete chip style?</Typography>).then(() =>
            {
                remove(`constants/${project}/${constant}/chip/`).catch(console.error);
            }).catch(() => { });
        }
    }
    const handleAutoChanged = () =>
        setChipStyle(id, constant.chip === "auto" ? getInitialStyle() : "auto");
    const handleSetFormatStyle = (style: StyleOptions) => setChipStyle(id, style);
    const handleChipValueChanged = (data: any) => {
        set(`constants/${project}/${id}/chipValue`, data);
    }
    return (
        <Box className={classes.form}>
            <FormControlLabel control={
                <Switch checked={constant.chip === "auto"} onChange={handleAutoChanged} />
            } label="Auto Style" />
            {constant.type === "date" &&
                <DateTimePicker date={constant.chipValue as number} onValueChange={handleChipValueChanged}/>
            }
            {constant.chip !== "auto" &&
                <FormattingStyleOptions formatStyle={constant.chip ?? {}} setFormatStyle={handleSetFormatStyle}/>}
            <Box display="flex" justifyContent="right" marginLeft={1} marginRight={1}>
                <Button data-constant={id} data-value={value} onClick={handleDeleteChip} variant="contained">
                    <Delete />
                </Button>
            </Box>
        </Box>
    );
}